<template>
    <section class="pressReleases">
        <div class="wrapper">
            <h2 class="h2 pressReleases__h2">
                Пресс-релизы
            </h2>
            <UITabs :tabs="tabsData">
                <template
                    v-for="{slotName} in tabsData"
                    #[slotName]
                >
                    <PressReleaseItem
                        :key="slotName"
                        :type="slotName"
                    />
                </template>
            </UITabs>
        </div>
    </section>
</template>

<script>
import {defineComponent} from 'vue';

import PressReleaseItem from '@/components/Pages/HomePage/PressReleases/PressReleaseItem.vue';
import UITabs from '@/components/UI-components/Tabs/UITabs.vue';

const tabsData = [
    {
        slotName: 'news',
        label: 'Новости',
    },
    {
        slotName: 'articles',
        label: 'Книги и статьи',
    },
    {
        slotName: 'mass-media',
        label: 'СМИ о нас',
    },
];

export default defineComponent({
    name: 'PressReleases',
    components: {
        PressReleaseItem,
        UITabs,
    },
    setup() {
        return {
            tabsData,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/press-releases';
</style>
